/* eslint-disable no-console */
// Console Interceptor Service
// Captures all console logs from app initialization for debugging

class ConsoleInterceptor {
  constructor() {
    this.consoleLogs = []
    this.maxLogEntries = 100
    this.originalMethods = {}
    this.isSetup = false
    this.errorCallbacks = [] // Callbacks for console.error
  }

  setupInterceptor() {
    if (this.isSetup) return
    
    const methods = ['log', 'warn', 'error', 'info', 'debug']
    
    methods.forEach(method => {
      this.originalMethods[method] = console[method]
      console[method] = (...args) => {
        // Call original method
        this.originalMethods[method].apply(console, args)
        
        // Capture the log
        const logEntry = {
          type: method,
          message: args.map(arg => {
            if (arg === undefined) return 'undefined'
            if (arg === null) return 'null'
            if (typeof arg === 'object') {
              try {
                return JSON.stringify(arg, null, 2)
              } catch {
                return String(arg)
              }
            }
            return String(arg)
          }).join(' '),
          timestamp: new Date().toISOString()
        }
        
        // Only add stack for errors
        if (method === 'error') {
          const stack = (new Error()).stack
          if (stack) {
            logEntry.stack = stack
          }
        }
        
        this.consoleLogs.push(logEntry)
        
        // Keep only the last N entries
        if (this.consoleLogs.length > this.maxLogEntries) {
          this.consoleLogs.shift()
        }

        // Notify error callbacks for console.error
        if (method === 'error') {
          this.errorCallbacks.forEach(cb => {
            try {
              cb(args, logEntry)
            } catch {
              // Prevent callback errors from breaking console
            }
          })
        }
      }
    })

    this.isSetup = true
    console.log('[ConsoleInterceptor] Console logging interceptor initialized')
  }

  getConsoleLogs() {
    return [...this.consoleLogs]
  }

  clearLogs() {
    this.consoleLogs = []
  }

  /**
   * Register a callback for console.error calls
   * Returns an unsubscribe function
   */
  onError(callback) {
    this.errorCallbacks.push(callback)
    return () => {
      this.errorCallbacks = this.errorCallbacks.filter(cb => cb !== callback)
    }
  }
}

// Create singleton instance
export const consoleInterceptor = new ConsoleInterceptor()